import React from 'react';
import { Box, DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type Props = {
    title: string;
    onClose: () => void;
};

export const SupportModalTitle = ({ title, onClose }: Props) => (
    <DialogTitle>
        <Box display="flex" alignItems="center">
            <Box flexGrow={1}>
                <Typography variant="h4">{title}</Typography>
            </Box>
            <Box>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
        </Box>
    </DialogTitle>
);
